import React, { useState } from "react";

import {
  Delete as DeleteIcon,
  Edit as EditIcon,
  Add as AddIcon,
} from "@material-ui/icons";
import DataTable from "../../../components/data-table";
import FormModalContent from "./form";
import ConfirmModalContent from "../../../components/confirm-modal-content";
import lensesService from "../../../services/lenses.service";
import { useEffect } from "react";

const headerCells = [
  {
    field: "name",
    title: "نام",
    mainField: true,
  },
];
const defaultKeys = [
  {
    title: "نام",
    field: "name",
    active: true,
  },
];

export default function LensesPage() {
  const [data, setData] = useState([]);
  const deleteItem = (item) => {
    return lensesService.deleteLens(item.id);
  };

  useEffect(() => {
    onRefresh();
  }, []);

  const onRefresh = async () => {
    const { data, error } = await lensesService.getLenses();
    if (error) {
      // handleError(error);
      return;
    }
    setData(data);
  };

  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد عدسی",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        // actions={[
        //   {
        //     icon: <AddIcon />,
        //     tooltip: "ایجاد زیر خدمت",
        //     modalContent: (props) => (
        //       <FormModalContent {...props} serviceId={id} />
        //     ),
        //     modalProps: { maxWidth: "sm" },
        //   },
        // ]}
        searchKeys={defaultKeys}
        data={data}
        onRefresh={onRefresh}
        title="عدسی"
      />
      {/* <DataTable
        headCells={headerCells}
        backend={lensesService.getLensesUrl}
        rowActions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <EditIcon />,
            modalContent: (props) => <FormModalContent {...props} />,
          },
          {
            modalProps: { maxWidth: "sm" },
            icon: <DeleteIcon />,
            modalContent: (props) => (
              <ConfirmModalContent
                onConfirm={() => deleteItem(props.data)}
                confirmText={props.data.name}
                close={props.close}
              />
            ),
          },
        ]}
        actions={[
          {
            modalProps: { maxWidth: "sm" },
            icon: <AddIcon />,
            tooltip: "ایجاد عدسی",
            modalContent: (props) => <FormModalContent {...props} />,
          },
        ]}
        searchKeys={defaultKeys}
        title="عدسیها"
      /> */}
    </div>
  );
}
